export const newVersion = (versionNumber, editedBy, date) => ({
    type : 'NEW_VERSION',
    versionNumber,
    editedBy,
    date
});